module.exports = __webpack_public_path__ + "img/index-3-pic05@2x.0c36318b.png";